var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.335 44.7256C24.9303 45.3209 25.6745 45.6186 26.4187 45.6186C27.1629 45.6186 27.9071 45.3209 28.5024 44.7256L48.2234 25.0047C49.4141 23.814 49.4141 21.9535 48.2234 20.7628C47.0327 19.5721 45.1722 19.5721 43.9815 20.7628L26.4187 38.4L18.4559 30.4372C17.2652 29.2465 15.4048 29.2465 14.2141 30.4372C13.0234 31.6279 13.0234 33.4884 14.2141 34.6791L24.335 44.7256Z",
    fill: "#0075FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6372 64 64 49.6372 64 32C64 14.3628 49.6372 0 32 0C14.3628 0 0 14.3628 0 32C0 49.6372 14.3628 64 32 64ZM32 5.95349C46.3628 5.95349 58.0465 17.6372 58.0465 32C58.0465 46.3628 46.3628 58.0465 32 58.0465C17.6372 58.0465 5.95349 46.3628 5.95349 32C5.95349 17.6372 17.6372 5.95349 32 5.95349Z",
    fill: "#0075FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChecked);
export default __webpack_public_path__ + "static/media/circleChecked.b3ea2c1e.svg";
export { ForwardRef as ReactComponent };